import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Label, FormGroup, Button } from "reactstrap";
import { getCategories } from "../../redux/actions/indexActions";
import CKEditor from "react-ckeditor-component";
const UpdateLocation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList },
  } = useSelector((state) => state);
  const [errors, setErrors] = useState({});
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [categoryList, setcategoryList] = useState([]);
  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    title_english: "",
    status: 1,
    image: "",
    short_description: "",
    latitude: "",
    longitude: "",
    map_url: "",
    description: "",
  });
  const navigate = useNavigate();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "image") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleDescription = (e) => {
    const description = e.editor.getData();
    setFormData((prev) => ({
      ...prev,
      description: description,
    }))
  }
  useEffect(() => {

    axios.get(`/api/admin/v1/state-list`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    }).then((res) => {
      // setCourseCategory([])
      setcategoryList(
        res.data.stateLists?.map((item) => ({ state_name: item.state_name, id: item.id }))
      );
    })
      .catch((err) => console.error(err));

  }, []);

  useEffect(() => {
    if (formData?.category_id) {
      axios(`/api/admin/v1/get-city/${formData?.category_id}`)
        .then(({ data }) => {
          console.log(data, 'ldad');
          setSubCategoryList(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [formData?.category_id]);


  useEffect(() => {
    if (id) {
      axios(`/api/admin/v1/location/${id}`, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
        .then((res) => {
          setFormData((prev) => {
            return {
              ...prev,
              category_id: res.data?.locations?.state?.id,
              sub_category_id: res.data?.locations.city?.id,
              title_english: res.data?.locations?.town_name,
              status: res.data?.locations?.status,
              image: res.data?.locations?.image,
              short_description: res.data?.locations?.short_description,
              description: res.data?.locations?.description,
              latitude: res.data?.locations?.latitude,
              longitude: res.data?.locations?.longitude,
              map_url: res.data?.locations?.map_url,
            };
          });
        }).catch((err) => console.log(err));
    }
  }, [id, auth, categoriesList]);

  const handleSubmit = () => {
    const form = new FormData();
    form.append("category_id", formData.category_id);
    form.append("sub_category_id", formData.sub_category_id);
    form.append("title_english", formData.title_english);
    form.append("image", formData.image);
    form.append("latitude", formData.latitude);
    form.append("longitude", formData.longitude);
    form.append("map_url", formData.map_url);
    form.append("short_description", formData.short_description);
    form.append("description", formData.description);
    form.append("status", formData.status);
    axios.put(`/api/admin/v1/location/${id}`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${auth?.token}`,
      },
    }).then((res) => {
      toast.success(res.data?.message);
      navigate(-1);
    }).catch((err) => {
      toast.error(err.response.data);
      setErrors(err.response.data);
    });
  };


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h5 className="text-white">Edit Town</h5>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          {/* <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category Type</Label>
              <Multiselect className="text-black"
                options={categoriesList}
                displayValue="name"
                selectedValues={formData.consultanttype}
                onSelect={(val) =>
                  setFormData({ ...formData, consultanttype: [...val] })
                }
              />
            </FormGroup>
          </div> */}
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Category</option>
                {categoryList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item?.state_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Sub Category<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.sub_category_id}
                type="select"
                name="sub_category_id"
                onChange={inputHandler}
              >
                <option value="">Select Sub Category</option>
                {subCategoryList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item?.city_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.sub_category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Town Name <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.title_english}
                name="title_english"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.title_english}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Image</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.image)}
                name="image"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.image}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Description</Label>
              <Input
                type="textarea"
                invalid={Boolean(errors?.short_description)}
                value={formData?.short_description}
                name="short_description"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.short_description} </span>
            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Full Description <span className="text-danger fs-4">*</span></Label>
              <FormGroup>
                <CKEditor content={formData.description} events={{ "change": handleDescription }} />
              </FormGroup>
              <span className="d-block text-danger">{errors?.description}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Latitude <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.latitude)} value={formData?.latitude} name="latitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.latitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Longitude <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.longitude)} value={formData?.longitude} name="longitude" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.longitude} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Map Url <span className="text-danger fs-4">*</span></Label>
              <Input invalid={Boolean(errors?.map_url)} value={formData?.map_url} name="map_url" onChange={inputHandler} />
              <span className="d-block text-danger"> {errors?.map_url} </span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-5">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateLocation;
